import {CoreConfig, WithConfig} from './types'

export const getConfig = <TConfig = CoreConfig>(state: WithConfig<TConfig>) => state.config as TConfig
